export default __webpack_public_path__ + "static/media/VC.56dc1f92.svg";